import * as commonActions from './common'
import * as loginActions from './login'

export default {
    ...commonActions,
    ...loginActions
}
